(function ($) {
    'use strict';

    const STORAGE_KEY = 'pi_subscriber_email';
    let pendingPostId  = null;

    function isSubscribed() {
        return !!localStorage.getItem(STORAGE_KEY);
    }

    function saveEmail(email) {
        localStorage.setItem(STORAGE_KEY, email);
    }

    function openModal() {
        $('#download-modal-overlay').fadeIn(200);
        $('body').css('overflow', 'hidden');
    }

    function closeModal() {
        $('#download-modal-overlay').fadeOut(200);
        $('body').css('overflow', '');
    }

    // Download via proxy form POST — stays on page, bypasses DLM redirect
    function startDownload(postId) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = ajax_callback_data.ajax_url;
        form.target = '_blank'; // new tab — stays on current page

        const fields = {
            action:     'dlm_proxy_download',
            ajax_nonce: ajax_callback_data.ajax_nonce,
            post_id:    postId,
        };

        Object.entries(fields).forEach(([key, val]) => {
            const input    = document.createElement('input');
            input.type     = 'hidden';
            input.name     = key;
            input.value    = val;
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    // Intercept BEFORE Download Monitor
    document.addEventListener('click', function(e) {
        const link = e.target.closest('a.dlm-subscribe-gate');
        if (!link) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        // Store post ID for download
        pendingPostId = link.getAttribute('data-post-id');

        if (ajax_callback_data.is_logged_in === 'true' || isSubscribed()) {
            startDownload(pendingPostId);
        } else {
            openModal();
        }

    }, true);

    // Close modal
    $('#download-modal-close').on('click', closeModal);
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') closeModal();
    });
    $('#download-modal-overlay').on('click', function(e) {
        if ($(e.target).is('#download-modal-overlay')) closeModal();
    });

    // Watch for GF confirmation
    function handleConfirmation() {
        const $data = $('#gf-subscriber-data');
        if ($data.length && $data.data('email')) {
            saveEmail($data.data('email'));
            setTimeout(function() {
                closeModal();
                startDownload(pendingPostId); // stays on page
            }, 1000);
        }
    }

    $(document).on('gform_confirmation_loaded', handleConfirmation);

    const observer = new MutationObserver(handleConfirmation);
    const modalBody = document.getElementById('download-modal-body');
    if (modalBody) {
        observer.observe(modalBody, { childList: true, subtree: true });
    }

})(jQuery);